<template>
  <section id="gallerySection" class="gallery-section">
    <div class="content">
      <h2 class="title">{{ title ? title : translations[lang].title }}</h2>

      <div class="swiper-overlay">
        <button class="swiper-nav swiper-nav-next" @click="swiper.slideNext()"></button>
        <button class="swiper-nav swiper-nav-prev" @click="swiper.slidePrev()"></button>
        <swiper :loop="true" :modules="modules" :slides-per-view="1" :space-between="10" :speed="750" @swiper="onSwiper">
          <swiper-slide v-for="(item, index) in slides[lang]" :key="index">
            <GallerySlide :slide="item" :index="index" :lang="lang" />
          </swiper-slide>
        </swiper>
      </div>
      <div class="trust__button">
        <button v-text="translations[lang].button" class="btn-ask-demo custom-button" @click="openDemoForm()" />
      </div>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay } from 'swiper/modules';
import GallerySlide from '@/Components/En/Common/GallerySlide.vue';

import 'swiper/swiper-bundle.css';

export default {
  name: 'Gallery',
  components: {
    Swiper,
    SwiperSlide,
    GallerySlide,
  },
  props: {
    close: {
      default: () => null,
      type: Function,
    },
    openDemoForm: {
      default: () => null,
      type: Function,
    },
    lang: {
      type: String,
      default: 'en',
    },
    title: {
      type: String,
      default: null,
    },
  },
  setup() {
    return {
      modules: [Autoplay],
    };
  },
  data() {
    return {
      swiper: null,
      slides: {
        en: [
          { subtitle: 'ImmoProperty LTD project' },
          { subtitle: 'Highsite project' },
          { subtitle: 'Cottage community' },
          { subtitle: '3d offices Dark project' },
          { subtitle: 'Palmbeach Con Jardin project' },
          { subtitle: 'Old Town project' },
          { subtitle: 'Farmhouse project' },
          { subtitle: 'Hytte project' },
          { subtitle: 'Richford project' },
          { subtitle: 'PrimProperty project' },
          { subtitle: 'Jaconda project' },
        ],
        ru: [
          { subtitle: 'Проект «Теплые зори»' },
          { subtitle: 'Проект «Ривер»' },
          { subtitle: 'Проект «Мягкая классика»' },
          { subtitle: 'Проект «Нега»' },
          { subtitle: 'Проект «Свой уголок»' },
          { subtitle: 'Проект «Краски»' },
          { subtitle: 'Проект «Родная долина»' },
          { subtitle: 'Проект «Мой уголок»' },
          { subtitle: 'Проект «Офисы у дома»' },
        ],
      },
      translations: {
        en: {
          title: 'Gallery created by AI',
          button: 'Getting Demo',
        },
        ru: {
          title: 'Галерея, создано ИИ',
          button: 'Хочу Демо',
        },
      },
    };
  },

  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },
  },
};
</script>
